import { api } from "./apiService";
import { buildHeaders, getApiBaseUrl } from "@/utils/getApiBaseUrl";
import { RegisterPayload, LoginPayload, OTPPayload, SocialAuthPayload, UpdateProfilePayload } from "@/types/common";

export const authService = {
  register: (payload: RegisterPayload) => {
    return api.post("/api/auth/register", payload);
  },

  login: (payload: LoginPayload) => {
    return api.post("/api/auth/login", payload);
  },

  verifyCreate: (payload: RegisterPayload) => {
    return api.post("/api/auth/verify-create", payload);
  },

  verifyOtp: (payload: OTPPayload) => {
    return api.post("/api/auth/verify-otp", payload);
  },

  getAll: (master: string, params: string | null = null) => {
    return api.get(
      `/api/auth/${master}${params ? `?${params}` : ""}`
    );
  },

  googleLogin: (payload: SocialAuthPayload) => {
    return api.post("/api/auth/google-sso", payload);
  },

  LinkedInSignupLogin: (payload: SocialAuthPayload) => {
    return api.post("/api/auth/linkedin-sso", payload);
  },

  // updateProfile: (payload: any) => {
  //   return api.post(`api/auth/update-user`, payload)
  // }

  updateProfile: async (token: string, payload: UpdateProfilePayload) => {

    try {
      const response = await fetch(
        `${getApiBaseUrl() || process.env.NEXT_PUBLIC_API_BASE_URL}/api/auth/update-user`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`,
            ...buildHeaders(token, 'updateProfile', ''),
          },
          body: JSON.stringify({...payload}),
          cache:'no-store',
          next: { revalidate: 0 }, // Cache for 30 seconds
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error submitting Article Attachment Download form:", error);
      throw error; // Re-throw to handle in the calling component
    }
  },

};
